import styled, { css } from "styled-components"

import {
  colors,
  spacing,
  size,
  typography,
  borderRadius,
  IconSimpleArrowUpSmall,
  IconSimpleArrowDownSmall,
} from "@izettle/otto"
import { getHorizontalPaddingAndBorderWidth, Icon } from "@izettle/react"

const dropdownHandlerPaddingAndBorderWidth = getHorizontalPaddingAndBorderWidth("small")

type ButtonProps = {
  isOpen: boolean
}

const dropdownSelectHandlerStates = {
  closedDefault: css`
    border-color: ${colors.action.minor.border.default};
    background: ${colors.background.default};
    color: ${colors.action.minor.text.default};
  `,
  closedHover: css`
    background: ${colors.background.default};
    border-color: ${colors.action.minor.border.hover};
    color: ${colors.action.minor.text.hover};
  `,
  openDefault: css`
    background: ${colors.background.default};
    border-color: ${colors.action.primary.border.default};
    color: ${colors.action.inline.text.default};
  `,
  openHover: css`
    background: ${colors.background.default};
    border-color: ${colors.action.primary.border.hover};
    color: ${colors.action.secondary.text.hover};
  `,
  active: css`
    transition-duration: 0s;
    background: ${colors.background.default};
    border-color: ${colors.action.primary.border.selected};
    color: ${colors.action.secondary.text.default};
  `,
  disabled: css`
    background: ${colors.action.secondary.background.disabled};
    border-color: ${colors.action.secondary.border.disabled};
    color: ${colors.action.secondary.text.disabled};
    cursor: not-allowed;
  `,
}

export const Button = styled.button.attrs({ type: "button" })<ButtonProps>`
  ${typography.regular}

  height: ${size.medium};
  width: 100%;
  padding: 0 ${spacing.small};

  border: 1px solid;

  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;

  border-radius: ${borderRadius.medium};
  cursor: pointer;
  outline: none;
  user-select: none;

  transition:
    background-color 0.12s ease-in,
    border-color 0.12s ease-in,
    color 0.12s ease-in;

  ${dropdownHandlerPaddingAndBorderWidth("1px")}
  ${dropdownSelectHandlerStates.closedDefault}

  :hover, :focus {
    ${dropdownSelectHandlerStates.closedHover}
  }

  ${({ isOpen }) =>
    isOpen &&
    css`
      ${dropdownHandlerPaddingAndBorderWidth("2px")}
      ${dropdownSelectHandlerStates.openDefault}

    :hover, :focus {
        ${dropdownSelectHandlerStates.openHover}
      }
    `}

  :active {
    ${dropdownHandlerPaddingAndBorderWidth("2px")}
    ${dropdownSelectHandlerStates.active}
  }

  :disabled {
    ${dropdownSelectHandlerStates.disabled}
  }
`

export const Text = styled.div`
  flex: 1;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const ChevronStyle = styled.div`
  margin-left: ${spacing.small};
`

export const Chevron = ({ isUp }: { isUp?: boolean }) => {
  return (
    <ChevronStyle>
      <Icon block svgIcon={isUp ? IconSimpleArrowUpSmall : IconSimpleArrowDownSmall} />
    </ChevronStyle>
  )
}

export const Badge = styled.div`
  font-weight: 500;
`
